import { defineDocument } from '../../schema';
export const blogPartyGameStreamingByTheNumbersFebruary2026Document = defineDocument({
    id: 'blog:party-game-streaming-by-the-numbers-february-2026',
    kind: 'blog',
    slug: 'party-game-streaming-by-the-numbers-february-2026',
    route: '/blog/party-game-streaming-by-the-numbers-february-2026',
    seo: {
        title: 'Party Game Streaming by the Numbers: February 2026',
        description: "February's biggest party-game breakout, plus the momentum signals shaping Twitch",
        imageAsset: 'twitchStats202602v2',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Party Game Streaming by the Numbers: February 2026',
            },
        ],
        description: [
            {
                type: 'text',
                text: "February's biggest party-game breakout, plus the momentum signals shaping Twitch",
            },
        ],
        imageAsset: 'twitchStats202602v2',
        imageAlt: 'Dynamic collage of top games and streamers for February 2026',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-03-03T00:00:00.000Z'),
        updatedAt: new Date('2026-03-03T00:00:00.000Z'),
        tags: ['party-central'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Today we are publishing the first edition of the ',
                        },
                        {
                            type: 'strong',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Airhead Games Streaming Report',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ', a monthly look at which party games are thriving on Twitch, which streamers are driving the scene, and where in the world party gaming is catching on. The ',
                        },
                        {
                            type: 'link',
                            href: '/party-central/reports/2026-02-top-party-games-and-streamers',
                            children: [
                                {
                                    type: 'text',
                                    text: 'full February 2026 report',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' covers Feb 12 through 28 (a partial month, since this is our debut edition) across hundreds of games, tens of thousands of streamers, and 34 languages. Here are the highlights.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__what-party-score-measures',
                    title: [
                        {
                            type: 'text',
                            text: 'What Party Score Measures',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Party Score',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' is our branded ranking metric for party game performance on Twitch. It combines adoption, repeat play behavior, and audience performance so each game can be compared on one scale. This report sources game metadata from IGDB, filters titles using party-related tags, and checks Twitch activity in our stream dataset. For formulas, thresholds, and edge-case handling, read the ',
                                },
                                {
                                    type: 'link',
                                    href: '/party-central/reports#methodology',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'full methodology',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__the-top-games',
                    title: [
                        {
                            type: 'text',
                            text: 'The Top Games',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Diablo II: Resurrected',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " tops the Party Score rankings, powered by the largest streamer base and strong repeat play. But the top 15 tells a richer story: Nintendo titles claim four spots (Super Smash Bros. Ultimate, Mario Kart World, Super Mario Party Jamboree, and Mario Kart 64), two mahjong games appear (reflecting the genre's rising global profile on streaming platforms), and established favorites like Among Us, Fall Guys, and Jackbox Party Packs all land in the mix.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'On the retention side, ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Words On Stream',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' posted one of the highest stickiness scores of any game with its dedicated community averaging over nine sessions each in just 17 days. That kind of daily-habit engagement is rare in party gaming, where most established titles (Among Us, Fall Guys, Jackbox) clock closer to once-a-week play.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The breakout story of February is ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Super Battle Golf',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. Built by indie studio ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://brimstone.games/',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Brimstone',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' in just 4.5 months, the game launched on Feb 19, ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://store.steampowered.com/news/app/4069520/view/497221052658616493',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'sold 100,000 copies in 48 hours',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', and earned an ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://store.steampowered.com/app/4069520/Super_Battle_Golf/',
                                    children: [
                                        {
                                            type: 'text',
                                            text: '"Overwhelmingly Positive" rating on Steam',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. The formula translates perfectly to Twitch: up to eight players competing simultaneously with orbital lasers, rocket launchers, and land mines at a price point that makes community buy-in effortless. In just 10 days, it attracted more unique streamers than Fall Guys and appeared in audience or volume charts across six different languages.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__streamers-worth-watching',
                    title: [
                        {
                            type: 'text',
                            text: 'Streamers Worth Watching',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/gaules',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Gaules',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' is the standout streamer of February. A former professional Counter-Strike player and the first coach to win a CS world championship (MIBR, 2007), Gaules now streams daily and covered nine different party games during the reporting window. No other creator combined that kind of breadth with a large, consistent audience. For contrast, ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/caseoh_',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'caseoh_',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' brought tens of thousands of viewers to Fall Guys across just three sessions, showing how party games often serve as palette-cleanser content for mega-streamers.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The report surfaces a range of creator profiles worth following: ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/karacorvus',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'KaraCorvus',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', a scientist turned variety streamer covering five games; ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/logan_usa',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'logan_usa',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', the #1 ranked Mario Kart Wii time trialer bringing competitive credibility to the genre; and ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/francesconigris',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'francesconigris',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', who converted a TikTok following into a thriving Twitch presence. For sheer range, ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/partychads',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'PARTYCHADS',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' played 13 different party games in 17 days.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__a-genuinely-global-scene',
                    title: [
                        {
                            type: 'text',
                            text: 'A Genuinely Global Scene',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'English accounts for the majority of streams, but each language community has its own flavor. Mahjong dominates Japanese and Chinese streaming, Just Dance draws audiences in Spanish, Polish, and Italian, and Russian streamers have built a niche around Gartic Phone and Jackbox. The full report breaks down the top 10 languages in detail.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__dive-into-the-full-report',
                    title: [
                        {
                            type: 'text',
                            text: 'Dive Into the Full Report',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'This is the baseline for our monthly Streaming Report series which will be published next in early April for March 2026. Read the ',
                                },
                                {
                                    type: 'link',
                                    href: '/party-central/reports/2026-02-top-party-games-and-streamers',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'full February report',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' for complete rankings and game-by-game analysis.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=party-game-streaming-by-the-numbers-february-2026.js.map